import {FeatureCaseItem} from "./feature-case-item";

export class FeatureCases {
    constructor() {
        this.DOM = {main: document.querySelector('.js-featureCases')};
        if (!this.DOM.main) return;

        this.DOM.cases = this.DOM.main.querySelector('.js-cases');

        this.active = 0;
        this.caseItems = [];
        this.init();
    }

    init() {
        this.DOM.main.querySelectorAll('.js-case').forEach((el, key) => {
            this.caseItems.push(new FeatureCaseItem({
                el, key,
                onHover: this.onEnter.bind(this),
                onLeave: this.onLeave.bind(this)
            }));
        });
        this.DOM.cases.classList.add('is-active');
        this.caseItems[this.active].enter();
    }

    onEnter(key) {
        if (key !== this.active) {
            this.caseItems[this.active].leave();
            this.active = key;
        }
        this.DOM.cases.classList.add('is-active');
    }

    onLeave(key) {
        if (key === this.active) this.caseItems[this.active].enter();
        this.DOM.cases.classList.remove('is-active');
    }
}